<template>
  <div class="form-checkbox form-checkbox--small">

    <input type="checkbox"
           v-model="checkedHandler"
           :disabled="disabled"
           :id="uid"
           :value="value"
           />

    <label :for="uid"
           class="form-checkbox__label"
    >
      <span class="form-checkbox__label-text">
        {{ label }}
      </span>
    </label>

  </div>
</template>

<script>
let uid = 0;

export default {
  name: 'Checkbox',

  props: {
    label: {
      type: String,
    },
    checked: {
      type: [
        Array,
        Boolean,
      ],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      required: true,
    },
  },

  data: () => {
    uid += 1;

    return {
      uid: `checkbox-${uid}`,
    };
  },

  computed: {
    checkedHandler: {
      get() {
        return this.checked;
      },
      set(value) {
        this.$emit('update:checked', Array.isArray(value) && value.length === 0 ? undefined : value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .form-checkbox {
    padding: 4px 0;

    &__label {

      &-text {
        overflow: hidden;
        line-height: 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>
